// extracted by mini-css-extract-plugin
export var addButton = "_e2-0";
export var border = "_e2-8";
export var check = "_e2-h";
export var danger = "_e2-6";
export var dropdownContainer = "_e2-1";
export var editModalBody = "_e2-j";
export var footerContainer = "_e2-i";
export var fullWidth = "_e2-a";
export var hide = "_e2-9";
export var icon = "_e2-3";
export var input = "_e2-7";
export var inputFlex = "_e2-b";
export var inputWrapper = "_e2-c";
export var manualFocus = "_e2-5";
export var optionButton = "_e2-4";
export var pillWrapper = "_e2-e";
export var pointer = "_e2-2";
export var showOverflow = "_e2-f";
export var tagsFlex = "_e2-d";
export var xButton = "_e2-g";